












































































import { Vue, Component } from "vue-property-decorator";
import adminService from "@/services/AdminService";

@Component
export default class GeoEmissionsImport extends Vue {
  private emissionsFile: any = null;
  private emissionsFileUpdate: any = null;
  private populationFile: any = null;
  private grpFile: any = null;

  public emissionsFileChanged(event) {
    this.emissionsFile = event.target.files[0];
  }

  public async importEmissions() {
    let formData = new FormData();
    formData.append("file", this.emissionsFile);
    await adminService.importGeoAreaEmissions(formData);
  }

  public emissionsFileUpdateChanged(event) {
    this.emissionsFileUpdate = event.target.files[0];
  }

  public async importEmissionsUpdate() {
    let formData = new FormData();
    formData.append("file", this.emissionsFileUpdate);
    await adminService.importGeoAreaEmissionsUpdate(formData);
  }

  public populationFileChanged(event) {
    this.populationFile = event.target.files[0];
  }

  public async importPopulation() {
    let formData = new FormData();
    formData.append("file", this.populationFile);
    await adminService.importGeoAreaPopulation(formData);
  }

  public grpFileChanged(event) {
    this.grpFile = event.target.files[0];
  }

  public async importGrp() {
    let formData = new FormData();
    formData.append("file", this.grpFile);
    await adminService.importGeoAreaGrp(formData);
  }

  public async aggregate() {
    await adminService.aggregateGeo();
  }
}
